import { ComponentProps, useCallback } from 'react';

import { Button } from '../../Button';
import { Modal } from '../../Dialog';

interface SelectModalButtonProps<T> extends Omit<ComponentProps<typeof Button>, 'onClick'> {
  readonly selections: Set<T>;
  readonly isAllSelected: boolean;
  readonly max: number;
  readonly min: number;
  readonly onClick?: (values: Set<T>) => void;
}

function SelectModalButton<T>({
  selections,
  max,
  min,
  onClick,
  children = 'Assign',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isAllSelected: _isAllSelected,
  ...props
}: SelectModalButtonProps<T>) {
  const isDisabled = selections.size > max || selections.size < min;
  const onClickHandler = useCallback(() => {
    onClick?.(selections);
  }, [onClick, selections]);

  return (
    <Modal.Close asChild>
      <Button disabled={isDisabled} {...props} onClick={isDisabled ? undefined : onClickHandler}>
        {children}
      </Button>
    </Modal.Close>
  );
}

export { SelectModalButton };
